export enum DpkParam {

    SymbolId = "SymbolId",
    Direction = "Direction",
    Method = "method",
    Currency = "currency",
    Amount = "amount",
    Ric = "ric",
    direction = "direction"
}
